module.exports = __webpack_public_path__ + "img/americanexpress-dark-large.b0e443a9.svg";